<nav class="main-header navbar navbar-expand navbar-color navbar-light" style="margin-left: 0px;">
  <a [routerLink]="['/']">
  <img
      src={{logoUrl}}
      alt="AdminLTE Logo"
      class="brand-image"
    /></a>
</nav>
